import React from 'react'
import { useSelector } from 'react-redux'
import { Routes, Route, useLocation } from "react-router";

// Constants
import { ROUTE, COMMON_FEATURES } from '../../../constants'

/**
 * Components
 */
import { asyncComponent } from '../../../../../components'
import App from "../../../../v1/index";

 /**
 * Pages
 */
import SSOPanel from '../../../pages/SSOPanel'
import SSOLogin from '../../../pages/SSOLogin'
import SSOLoading from '../../../pages/SSOLoading'

const AsyncNotFoundPage = asyncComponent(() => import("../../../pages/NotFoundPage"));

const AuthSelector = () => {

    const auth = useSelector(state => state.root.auth)

    const _authSelector = () => {
        if(auth.loadingState) {
            return <SSOLoading />
        } else {
            if (auth.currentUser) {
                return <SSOPanel currentUser={auth.currentUser}/>
            } else {
                return <App />
                // return <SSOLogin />
            }
        }
    }

    return (
        <>
        {
            _authSelector()
        }
        </>
    )
}

const SSORoutes = () => {
  const location = useLocation();

  const { state = {} } = location;

  const verify = state && state.verify;
  const authid = state && state.authid;

    return (
        <>
            <Routes>

                <Route
                    exact
                    path={ROUTE.MODULE_ROUTE.Login}
                    element={<SSOLogin/>}
                />

                <Route 
                    index
                    path={ROUTE.MODULE_ROUTE.Landing_Page} 
                    element={<AuthSelector />}
                />

                <Route element={<AsyncNotFoundPage />}/>

            </Routes>
        </>
    )
}

export default SSORoutes;